<template>
	<Modal
		@dismiss="$emit('dismiss')"
		:custom_style="{ width: '980px', 'min-height': '572px', 'max-height': '640px' }"
	>
		<div id="closeButtonWrapper">
			<button class="button-icon light button-close" type="button" @click="$emit('dismiss')">
				<img src="../../assets/img/icons/round-close-24px.svg" />
			</button>
		</div>
		<div id="pricingTierWrapper">
			<Pricing @showPaymentForm="$emit('showPaymentForm', { plan: $event.plan })" />
		</div>
	</Modal>
</template>

<script>
import Modal from "./modal";
import Pricing from "../pricing";

export default {
	components: {
		Modal,
		Pricing
	}
};
</script>

<style>
#closeButtonWrapper {
	position: relative;
}

#pricingTierWrapper {
	margin-top: 64px;
}
</style>